import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSquare, FiCheckSquare, FiTrash2 } = FiIcons;

function GoalItem({ goal, onToggle, onDelete }) {
  return (
    <div className="p-6 bg-gradient-to-r from-white to-gray-50 rounded-3xl shadow-lg mb-4 transition-all duration-200 transform hover:scale-102 border border-gray-100">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <button 
            onClick={() => onToggle(goal.id)}
            className="text-gray-400 hover:text-green-500 transition-colors duration-200 focus:outline-none p-2 rounded-xl hover:bg-green-50"
          >
            <SafeIcon 
              icon={goal.completed ? FiCheckSquare : FiSquare} 
              className={`text-2xl ${goal.completed ? 'text-green-500' : ''}`}
            />
          </button>
          <span className={`ml-4 text-lg font-medium ${goal.completed ? 'line-through text-gray-500' : 'text-gray-800'}`}>
            {goal.text}
          </span>
        </div>
        <button 
          onClick={() => onDelete(goal.id)}
          className="text-gray-400 hover:text-red-500 transition-colors duration-200 focus:outline-none p-2 rounded-xl hover:bg-red-50"
        >
          <SafeIcon icon={FiTrash2} className="text-xl" />
        </button>
      </div>
    </div>
  );
}

export default GoalItem;